// extracted by mini-css-extract-plugin
export default {"app":"App_app__4xG+3","mainWrapper":"App_mainWrapper__LPfSB","mainContent":"App_mainContent__VCn8-","authLayout":"App_authLayout__snkc+","appContent":"App_appContent__lI+Aj"};